// extracted by mini-css-extract-plugin
export default {"card":"forecast_card__aaM88"};